"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrumboardEvents = useScrumboardEvents;
const react_1 = require("react");
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
const EVENT_TYPES = [
    "contract-discussed-changed",
    "discussed-reset",
    "task-hours-changed",
    "hours-reset",
    "task-status-changed",
    "planning-changed",
    "absence-changed",
];
/**
 * Subskrybuje strumień SSE scrumboarda.
 * @param handlers mapa typ zdarzenia → handler (aktualizuje repository.items + stan)
 * @param onReconnect wywoływane po ponownym połączeniu (po zerwaniu) — pełny refetch
 */
function useScrumboardEvents(handlers, onReconnect) {
    // Trzymamy najświeższe handlery w ref, aby nie przepinać EventSource przy każdym renderze
    const handlersRef = (0, react_1.useRef)(handlers);
    handlersRef.current = handlers;
    const onReconnectRef = (0, react_1.useRef)(onReconnect);
    onReconnectRef.current = onReconnect;
    (0, react_1.useEffect)(() => {
        const source = new EventSource(`${MainSetupReact_1.default.serverUrl}scrumboard/events`, {
            withCredentials: true,
        });
        let hadError = false;
        const listeners = [];
        for (const type of EVENT_TYPES) {
            const listener = (event) => {
                const handler = handlersRef.current[type];
                if (!handler)
                    return;
                try {
                    handler(event.data ? JSON.parse(event.data) : {});
                }
                catch (err) {
                    console.error(`SSE handler error (${type}):`, err);
                }
            };
            source.addEventListener(type, listener);
            listeners.push([type, listener]);
        }
        source.onopen = () => {
            // Po reconnekcie (po błędzie) przeładuj dane — brak historii zdarzeń
            if (hadError) {
                hadError = false;
                onReconnectRef.current?.();
            }
        };
        source.onerror = () => {
            hadError = true; // EventSource sam ponowi połączenie
        };
        return () => {
            for (const [type, listener] of listeners)
                source.removeEventListener(type, listener);
            source.close();
        };
    }, []);
}
